import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const WaitlistStudentEnrollmentMutation = graphql.persisted(
  "WaitlistStudentEnrollment",
  graphql(`
    mutation WaitlistStudentEnrollment($studentEnrollmentId: ID!) {
      waitlistStudentEnrollment(input: {studentEnrollmentId: $studentEnrollmentId}) {
        studentEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { WaitlistStudentEnrollmentMutation };

export function useWaitlistStudentEnrollment() {
  return useMutation(WaitlistStudentEnrollmentMutation);
}
